<div class="modal-header">
  {{this.project | projectName}}&nbsp;
  <span i18n="@@transfer-small">übertragen</span>
</div>

<div class="modal-body">
  <div class="row mb-1 align-items-center">
    <div class="col-3"><label
        for="selectedUser"
        class="form-label"
        i18n="@@username"
      >Benutzer</label>
    </div>
    <div class="col">
      <p-select
        name="selectedUser"
        inputId="selectedUser"
        [options]="this.users"
        optionLabel="name"
        optionValue="_id"
        [(ngModel)]="this.project.creator"
      ></p-select>
    </div>
  </div>
</div>

<div class="modal-footer">
  <p-button
    type="button"
    severity="primary"
    label="Übertragen"
    i18n-label="@@transfer"
    (onClick)="this.transferProject()"
  ></p-button>
</div>